<ng-template #classic let-c="close" let-d="dismiss" id="info-modal">
    <div class="modal-content">
        <div class="d-flex flex-column align-items-center">
            <div class="modal-title text-center mb-3" id="modal-title-default">
                {{ 'TREE_COMP.INFO_MODAL_SECTRA_TITLE' | translate }}
            </div>
            <div class="text-center mb-4 analysis-title">
                <span class="modal-title"> {{ 'SECTRA_URL_MODAL.ANALYSIS_TYPE' | translate }} </span>
            </div>
            <mat-radio-group aria-labelledby="radio-group-label" class="analysis-radio-group"
                formControlName="analysisType" (change)="onAnalysisTypeChange($event)">
                @for (analysis of analysisTypes; track analysis) {
                <mat-radio-button class="analysis-radio-button" [value]="analysis.id"
                    [disabled]="!analysis.enabled">{{analysis.name}}</mat-radio-button>
                }
            </mat-radio-group>
            <div class="text-center font-14 mb-3" *ngIf="sectraUrl && enabledAnalysisTypes>0 && analysisTypeId">
                {{ sectraUrl }}&analysisTypeId={{ analysisTypeId }}
            </div>
        </div>
        <div class="d-flex justify-content-center">
            <button type="button" class="modal-ok-btn" ngbAutofocus (click)="modalReference.close(true)">
                {{ 'CONSTANTS.BTN_OK' | translate | uppercase }} </button>
        </div>
    </div>
</ng-template>
